import script from "./single-file-direct-uploader.vue?vue&type=script&setup=true&lang=ts"
export * from "./single-file-direct-uploader.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__